import wrapThunk from "../modules/wrap-thunk";
import { authenticatedRequest } from "../modules/api/auth";

import processVideoDetails from "../modules/data/process-video-details";
import processVideoSections from "../modules/data/process-video-sections";
import processVideoSkyview from "../modules/data/process-video-skyview";
import { selectPosition } from './time';

// Actions
const LIST_REQUEST = "superloci/videos/LIST_REQUEST";
const LIST_SUCCESS = "superloci/videos/LIST_SUCCESS";
const LIST_FAILURE = "superloci/videos/LIST_FAILURE";

const DETAILS_REQUEST = "superloci/videos/DETAILS_REQUEST";
const DETAILS_SUCCESS = "superloci/videos/DETAILS_SUCCESS";
const DETAILS_FAILURE = "superloci/videos/DETAILS_FAILURE";

const initialState = {
    list: { },
    listLoading: false,
    listError: null,

    detailsLoading: false,
    detailsError: null,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {

        // --------------
        // List
        case LIST_REQUEST: {
            return {
                ...state,
                listLoading: true,
                listError: null,
            };
        }
        case LIST_SUCCESS: {
            return {
                ...state,
                listLoading: false,
                list: {
                    ...state.list,
                    ...action.payload.list,
                }
            };
        }
        case LIST_FAILURE: {
            return {
                ...state,
                listLoading: false,
                listError: action.payload.error,
            }
        }

        // --------------
        // Details
        case DETAILS_REQUEST: {
            return {
                ...state,
                detailsLoading: true,
            };
        }
        case DETAILS_SUCCESS: {
            const { id, details, processed } = action.payload;
            const { list } = state;
            return {
                ...state,
                detailsLoading: false,
                list: {
                    ...list,
                    [id]: {
                        ...list[id],
                        ...processed,
                        details: details,
                    }
                }
            };
        }
        case DETAILS_FAILURE: {
            return {
                ...state,
                detailsLoading: false,
                detailsError: action.payload.error,
            }
        }
        default:
            return state;
    }
}

// Action Creators
export function videosListRequestAction() {
    return {
        type: LIST_REQUEST,
    }
}
export function videosListSuccessAction(list) {
    return {
        type: LIST_SUCCESS,
        payload: {
            list
        },
    };
}
export function videosListFailureAction(error) {
    return {
        type: LIST_FAILURE,
        payload: {
            error,
        }
    }
}

export function videoDetailsRequestAction() {
    return {
        type: DETAILS_REQUEST,
    }
}
export function videoDetailsSuccessAction(id, details, processed) {
    return {
        type: DETAILS_SUCCESS,
        payload: {
            id,
            details,
            processed,
        },
    };
}
export function videoDetailsFailureAction(error) {
    return {
        type: DETAILS_FAILURE,
        payload: {
            error,
        }
    }
}


// TODO: at some point, when pagination is a thing, we have to ensure either:
// - The api returns all the details in a "stats" request (preferred)
// OR
// - we can easily find the right page in the video list so the data is available that way.

export const getVideosList = () => {
    return wrapThunk(async dispatch => {
        dispatch(videosListRequestAction());
        const videoResponse = await authenticatedRequest("GET", "/list");
        if (videoResponse.response.ok) {
            const list = videoResponse.body.FileList.reduce((acc, next) => {
                acc[next.Id] = {
                    meta: next,
                };
                return acc;
            }, { })
            dispatch(videosListSuccessAction(list));      
            return list;
        } else {
            dispatch(videosListFailureAction(videoResponse));
            return null;
        }
    });
};

export const getVideoDetails = (id) => {
    return wrapThunk(async dispatch => {
        dispatch(videoDetailsRequestAction());
        const skyviewRequestPromise = authenticatedRequest("GET", `/skyview/${id}`);
        const detailsRequestPromise = authenticatedRequest("GET", `/stats/${id}`);
        const sectionsRequestPromise = authenticatedRequest("GET", `/skips/${id}`);
        const breakdownCountsRequestPromise = authenticatedRequest("GET", `/counts/${id}`);

        const detailsRequest = await detailsRequestPromise;
        const sectionsRequest = await sectionsRequestPromise;
        const skyviewRequest = await skyviewRequestPromise;
        const breakdownCountsRequest = await breakdownCountsRequestPromise;
        
        if (
            detailsRequest.response.ok &&
            sectionsRequest.response.ok &&
            breakdownCountsRequest.response.ok
        ) {
            const processedDetails = processVideoDetails(detailsRequest.body, breakdownCountsRequest.body);
            const processedSections = processVideoSections(sectionsRequest.body, detailsRequest.body);
            // Skyview is optional but highly encouraged.
            const processedSkyview = skyviewRequest.response.ok ? processVideoSkyview(skyviewRequest.body) : null;
            dispatch(videoDetailsSuccessAction(
                id,
                detailsRequest.body, // TODO: remove this and have a process func
                {
                    processed: processedDetails,
                    sections: processedSections,
                    skyview: processedSkyview,
                }
            ));       
        } else {
            dispatch(videoDetailsFailureAction(detailsRequest)); 
        }
    });
};

// ----
// Selectors

export const selectVideosList = (state) => Object.values(state.videos.list);
export const selectVideo = (id, state) => {
    if (!state.videos.list[id]) return null;
    if (!state.videos.list[id].details) return null;
    return state.videos.list[id];
}
export const selectCurrentSkyviewFrame = (state, video) => {
    if (!video.skyview) return null;
    const position = selectPosition(state);
    const { frames } = video.skyview;
    const currentFrame = frames.find(
        frame =>
            position >= frame.timeExtents[0] &&
            position < frame.timeExtents[1]
    );

    return currentFrame;
}



// WEBPACK FOOTER //
// ./src/ducks/videos.js